
<template>
  <div class="dashboard animated slideInRight">

    <!-- GAUGES -->
    <h2>{{items.activity.dashboard.title}}</h2>
    <div class="gauges left">
      <div class="gauge">
        <p>{{dashValues[0]}}%</p>
        <p>{{items.activity.dashboard.gauges[0]}}</p>
        <img src="media/page3/wand_mc.png" :style="{transform: 'rotate(' + dashValues[0] * 2 + 'deg)'}" />
      </div>
      <div class="gauge">
        <p>{{dashValues[1]}}%</p>
        <p>{{items.activity.dashboard.gauges[1]}}</p>
        <img src="media/page3/wand_mc.png" :style="{transform: 'rotate(' + dashValues[1] * 2 + 'deg)'}"/>
      </div>
      <div class="gauge">
        <p>{{dashValues[2]}}%</p>
        <p>{{items.activity.dashboard.gauges[2]}}</p>
        <img src="media/page3/wand_mc.png" :style="{transform: 'rotate(' + dashValues[2] * 2 + 'deg)'}" />
      </div>
    </div>
    <div class="gauges right">
      <div class="gauge">
        <p>{{dashValues[3]}}%</p>
        <div class="bar-outer">
          <div class="bar" :style="{height: dashValues[3] + '%'}"></div>
        </div>
        <p>{{items.activity.dashboard.gauges[3]}}</p>
      </div>
      <div class="gauge">
        <p>{{dashValues[4]}}%</p>
        <div class="bar-outer">
          <div class="bar" :style="{height: dashValues[4] + '%'}"></div>
        </div>
        <p>{{items.activity.dashboard.gauges[4]}}</p>
      </div>
      <div class="gauge">
        <div class="stars-outer far">
          <div class="stars-inner fas" :style="{width: dashValues[5] + '%'}"></div>
        </div>
        <p class="percent">{{dashValues[5]}}%</p>
        <p class="service">{{items.activity.dashboard.gauges[5]}}</p>
      </div>

      <!-- UNITS -->
      <div class="units">
        <div class="holder">
          <p>{{items.activity.dashboard.inventory[0]}}</p>
          <p>{{units.hand}}</p>
        </div>
        <div class="holder">
          <p>{{items.activity.dashboard.inventory[1]}}</p>
          <p>{{units.planned}}</p>
        </div>
      </div>
    </div>

    <!-- WARNINGS -->
    <slot name="warnings"></slot>
    <slot name="terminal"></slot>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  components: {},
  props: ["id", "dashValues", "units"]
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// Dashboard.vue?dbe5a3c2